<template>
  <div v-if="isSuccess">

    <b-container fluid>
      <b-row>
        <b-col>
          <b-alert variant="info" :show="dealers.length === 0">
            Você precisa criar um revendedor antes de imprimir.
            <router-link :to="{ name: 'OrganizerDealers' }">Criar revendedor</router-link>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-h="center" v-if="dealers.length !== 0">
        <b-col cols="12" lg="5">
          <h2>{{ $gui.tickets }}</h2>
          <b-form @submit.prevent="false">
            <b-form-group
              id="fieldset1"
              :label="'Escolha o ' + $gui.dealerLC"
              label-for="select-dealer">
                <b-form-select id="select-dealer"
                  :options="dealersOptions"
                  v-model="form.dealerId"
                  @input="dealerSelected"
                  class="mb-3">
                </b-form-select>
            </b-form-group>

            <b-form-group
              v-if="dealerChosen"
              :label="'Escolha um ' + $gui.batchLC">

                <b-form-radio-group
                  v-model="form.batchId"
                  :options="batchesOptions"
                  stacked>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group
              class="mt-4"
              v-if="batchChosen" label="Informe a quantidade:">

              <b-input-group prepend="Quantidade:">
                <b-form-input
                  v-model="form.quantity"
                  type="number"
                  value="1">
                </b-form-input>
                <b-input-group-append>
                  <b-btn @click="incrementQuantity">
                    <icon scale="1" name="plus"></icon>
                  </b-btn>
                  <b-btn @click="decrementQuantity">
                    <icon scale="1" name="minus"></icon>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>

              <b-btn
                class="mt-4"
                variant="success"
                @click="createTickets(form.dealerId, form.batchId, form.quantity)">
                  Imprimir
              </b-btn>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'OrganizerCreateTickets',
  data () {
    return {
      currentStatus: null,
      organizer: '',
      dealers: [],
      batches: [],
      tickets: {},
      reprintNumbers: [],
      form: {
        toggle: null,
        quantity: 1,
        dealer: {},
        dealerId: null,
        batchId: null
      },
      filters: {
        limit: 0,
        dealers: [],
        batches: [],
        numbers: '',
        rangeNumbers: '',
        createdAt: {
          start: '',
          end: ''
        }
      }
    }
  },
  created () {
    this.organizer = this.$route.params.organizer
    // this.getTickets('limit=10')
    this.getEvent()
  },
  methods: {
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      return this.$http.get(url).then(res => {
        if (res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }
        if (res.body.dealers.length > 0) {
          this.dealers = this.$_.orderBy(res.body.dealers, ['id'], ['asc'])
        }
        this.currentStatus = STATUS_SUCCESS
      }, err => {
        console.log(err)
        this.currentStatus = STATUS_FAILED
      })
    },
    getTickets (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer +
        '/tickets'

      if (filters !== '') {
        url = url + '?' + filters
      }

      return this.$http.get(url).then(res => {
        this.tickets = res.body.tickets
      }, err => {
        console.log(err)
      })
    },
    dealerSelected (dealerId) {
      this.dealerId = dealerId
      this.getDealer(dealerId)
    },
    getDealer (dealerId) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/dealers/' + dealerId

      return this.$http.get(url).then(res => {
        this.form.dealer = res.body
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    },
    filter () {
      let filters = []

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      // validar aqui o estilo das entradas
      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)
      }

      if (this.filters.createdAt.start !== '') {
        filters.push('start_created_at=' + this.filters.createdAt.start)
      }

      if (this.filters.createdAt.end !== '') {
        filters.push('end_created_at=' + this.filters.createdAt.end)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      this.getTickets(filters)
    },
    reprint () {
      if (this.reprintNumbers.length === 0) {
        alert('Selecione os ingressos que deseja reimprimir!')
        return
      }

      let msg = 'Estou ciente que um ingresso só é validado uma única vez por evento!' +
        '\nConfirme para reimprimir.'

      if (!confirm(msg)) {
        return
      }

      let numbers = this.$_.join(this.reprintNumbers, ',')
      this.reprintNumbers = []

      let route = this.$router.resolve({
        name: 'OrganizerReprintTickets',
        params: {
          organizer: this.organizer,
          numbers: numbers
        }
      })
      window.open(route.href, '_blank')
    },
    toggleTicket (value) {
      if (this.form.toggle === value) {
        this.form.toggle = null
      } else {
        this.form.toggle = value
      }
    },
    createTickets (dealerId, batchId, quantity) {
      let route = this.$router.resolve({
        name: 'OrganizerRenderTickets',
        params: {
          organizer: this.organizer,
          dealer: dealerId,
          batch: batchId,
          quantity: quantity
        }
      })
      this.form.quantity = 1
      window.open(route.href, '_blank')
    },
    incrementQuantity () {
      this.form.quantity++
    },
    decrementQuantity () {
      if (this.form.quantity > 1) {
        this.form.quantity--
      }
    }
  },
  computed: {
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    dealersOptions () {
      let aux = this.$_.filter(this.dealers, d => d.type === 'seller')
      return this.$_.map(aux, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchesOptions () {
      let ab = this.$_.filter(this.form.dealer.batches, b => b.is_available === 1)
      return this.$_.map(ab, b => {
        return {text: b.name, value: b.id}
      })
    },
    dealerChosen () {
      return this.$_.isEmpty(this.form.dealer) === false
    },
    batchChosen () {
      return this.form.batchId !== null
    }
  }
}
</script>
